var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { LibIcon } from './components';
var ImpactMeasurement = function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 74 : _c, _d = _a.title, title = _d === void 0 ? '' : _d, props = __rest(_a, ["isDisabled", "size", "title"]);
    return (React.createElement("svg", __assign({ width: 1.03 * size, height: size, viewBox: "0 0 76 74" }, props),
        title && React.createElement("title", null, title),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(-1052.000000, -432.000000)" },
                React.createElement("g", { transform: "translate(1052.000000, 432.000000)" },
                    React.createElement("rect", { fill: isDisabled ? '#BEBEC0' : '#15DE93', x: "55", y: "0", width: "21", height: "65", rx: "2" }),
                    React.createElement("rect", { fill: isDisabled ? '#ECE9E9' : '#FFDE49', x: "32", y: "15", width: "21", height: "50", rx: "2" }),
                    React.createElement("rect", { fill: isDisabled ? '#DEDEE0' : '#FF5160', x: "9", y: "30", width: "21", height: "35", rx: "2" }),
                    React.createElement("g", { transform: "translate(0.000000, 56.000000)" },
                        React.createElement("circle", { fill: isDisabled ? '#9F9F9F' : '#1E70DD', cx: "9", cy: "9", r: "9" }),
                        React.createElement("polyline", { stroke: "#FFFFFF", strokeWidth: "2.5", points: "4.5 9.42428561 7.95116564 12.3157895 12.3 4.73684211" })))))));
};
export var ImpactMeasurementIcon = function (_a) {
    var _b = _a.iconAriaHidden, iconAriaHidden = _b === void 0 ? true : _b, props = __rest(_a, ["iconAriaHidden"]);
    return (React.createElement(LibIcon, __assign({ icon: function () { return (React.createElement(ImpactMeasurement, { isDisabled: props.isDisabled, size: props.size, title: props.title, "aria-hidden": iconAriaHidden })); } }, props)));
};
//# sourceMappingURL=ImpactMeasurementIcon.js.map